import React from 'react';
import { motion } from 'framer-motion';
const volumes = [{
  number: '01',
  title: 'Inteligencia Emocional y Regulación Interna',
  description: 'Comprendé cómo funcionan las emociones, el estrés y la autorregulación para desarrollar mayor equilibrio emocional desde el primer día.'
}, {
  number: '02',
  title: 'Ansiedad, Miedo y Ataques de Pánico',
  description: 'Aprendé cómo funciona la ansiedad, por qué aparece y qué herramientas psicológicas ayudan a disminuir su impacto cotidiano.'
}, {
  number: '03',
  title: 'Autoestima, Amor Propio y Autovalor',
  description: 'Descubrí cómo fortalecer tu confianza, mejorar tu diálogo interno y construir una autoestima más estable.'
}, {
  number: '04',
  title: 'Reprogramación Mental y Creencias Limitantes',
  description: 'Transformá pensamientos automáticos, creencias limitantes y hábitos para desarrollar una mentalidad más saludable.'
}, {
  number: '05',
  title: 'Sanación del Niño Interior y Heridas Emocionales',
  description: 'Comprendé cómo ciertas experiencias pueden influir en tu presente y desarrollá una relación más saludable con vos mismo.'
}, {
  number: '06',
  title: 'La Nueva Identidad',
  description: 'Construí hábitos, propósito, resiliencia y una identidad alineada con la vida que realmente querés crear.'
}];
export function Tomos() {
  return <section id="temario" className="scroll-mt-8 bg-paper px-4 py-20 md:py-28" data-id="element-217" data-mp="3jge7b8xnci8x">
      <div className="mx-auto max-w-6xl" data-id="element-218" data-mp="3ofh4k77dxk6c">
        <div className="mx-auto max-w-3xl text-center" data-id="element-219" data-mp="3ogs6e1h9shut">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-220" data-mp="3sf9dil0oxsc8">El método, en profundidad</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-221" data-mp="1baxjawqji26">
            Formación completa organizada en 6 tomos profesionales
          </h2>
          <p className="mt-5 text-base leading-7 text-ink/65" data-id="element-222" data-mp="232eboa5u3erh">
            Un recorrido claro para entender lo que te pasa, incorporar recursos y llevarlos a tu vida cotidiana.
          </p>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2" data-id="element-223" data-mp="200t2mws02uok">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.08
        }} className="group flex gap-5 rounded-2xl border border-clay/15 bg-white p-6 transition-colors hover:border-clay/40" data-id="element-224" data-mp="1vz7s3i2xushj" data-mpi={index}>
              <span className="font-heading text-4xl font-semibold leading-none text-clay/75" data-id="element-225" data-mp="2euxw1auflyy2">{volume.number}</span>
              <div data-id="element-226" data-mp="2sq9sbmo8jxh3">
                <h3 className="font-heading text-2xl font-semibold leading-tight text-ink" data-id="element-227" data-mp="2nou3djixt6tf">{volume.title}</h3>
                <p className="mt-3 text-sm leading-6 text-ink/65" data-id="element-228" data-mp="32ltjjvruu7zi">{volume.description}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}